<template>
    <base-template v-if="product">
        <header class="header header-detail">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell">
                        <div class="header__content header-detail__content">
                            <router-link
                                :to="{name: 'home', params: {campaign: campaign}}"
                                class="btn-back">
                                <i class="icon-arrow_left" />
                            </router-link>

                            <h1>{{ product.title }}</h1>

                            <div class="header__intro text-line">
                                {{ product.provider.name }} <div class="dot">&nbsp;</div> {{ product.location.city }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <content-container>
            <template slot="content">
                <figure
                    class="figure-top"
                    :style="`background-image: url(${headerImage});`">
                    <img
                        v-if="headerImage"
                        :src="headerImage"
                        :alt="product.title">
                </figure>

                <div class="label-pusher content__label">
                    <activity-label :type="product.type" />
                </div>

                <div class="content__inner">
                    <h2>Algemene informatie</h2>

                    <h3 v-if="product.description">Omschrijving activiteit</h3>
                    <nl2br
                        tag="p"
                        v-if="product.description"
                        :text="product.description" />

                    <div class="content__block specs">
                        <div class="specs__item">
                            <i class="icon-user_group"/>

                            <div class="specs__content">
                                <div class="label-text">Leeftijd</div>
                                <p>{{ ageGroup }}</p>
                            </div>
                        </div>
                        <div class="specs__item">
                            <i class="icon-user_target"/>

                            <div class="specs__content">
                                <div class="label-text">Doelgroep</div>
                                <p>{{ targetAudience }}</p>
                            </div>
                        </div>
                    </div>

                    <h3 v-if="product.practical_info">Praktische informatie</h3>
                    <nl2br
                        tag="p"
                        v-if="product.practical_info"
                        :text="product.practical_info" />

                    <h3 v-if="product.additional_costs">Additionele kosten</h3>
                    <nl2br
                        tag="p"
                        v-if="product.additional_costs"
                        :text="product.additional_costs" />

                    <aside class="content__aside sidebar show-for-small-only">
                        <div class="sidebar__topfigure">
                            <img
                                src="@/assets/img/content/guy_cutted.png">
                        </div>

                        <div class="content__aside-inner">
                            <SidebarOpeningshours
                                v-if="product.type === 2"
                                :product="product" />
                            <SidebarEvents
                                v-else
                                :product="product" />
                        </div>
                    </aside>

                    <h2>Over deze aanbieder</h2>
                    <h3>{{ product.provider.name }}</h3>

                    <table class="activity-info">
                        <tr v-if="product.email">
                            <th class="label-text">E-mailadres</th>
                            <td>
                                <a
                                    :href="`mailto:${product.email}`">
                                    {{ product.email }}
                                </a>
                            </td>
                        </tr>
                        <tr v-if="product.phone">
                            <th class="label-text">Telefoonnummer</th>
                            <td>
                                <a
                                    :href="`tel:${product.phone}`">
                                    {{ product.phone }}
                                </a>
                            </td>
                        </tr>
                        <tr v-if="product.website">
                            <th class="label-text">Website</th>
                            <td>
                                <a
                                    :href="product.website | external_link"
                                    target="_blank">
                                    {{ product.website }}
                                </a>
                            </td>
                        </tr>
                        <!-- <tr>
                            <th class="label-text">Social media</th>
                            <td>
                                <div class="sharer">
                                    <a href="#"><i class="icon-facebook"/></a>
                                    <a href="#"><i class="icon-twitter"/></a>
                                    <a href="#"><i class="icon-instagram"/></a>
                                    <a href="#"><i class="icon-youtube"/></a>
                                </div>
                            </td>
                        </tr> -->
                    </table>
                </div>
            </template>

            <template slot="sidebar">
                <aside class="content__aside sidebar hide-for-small-only">
                    <div class="sidebar__topfigure">
                        <img
                            src="@/assets/img/content/guy_cutted.png">
                    </div>

                    <div class="content__aside-inner">
                        <SidebarOpeningshours
                            v-if="product.type === 2"
                            :product="product" />
                        <SidebarEvents
                            v-else
                            :product="product" />
                    </div>
                </aside>
            </template>
        </content-container>
    </base-template>
</template>

<script>
import ContentContainer from '@/components/base/ContentContainer.vue';
import BaseTemplate from '@/components/base/BaseTemplate.vue';
import ActivityLabel from '@/components/Label.vue';
import SidebarEvents from '@/components/activitydetail/SidebarEvents.vue';
import SidebarOpeningshours from '@/components/activitydetail/SidebarOpeningshours.vue';
import { FallbackImage } from '@/helpers';
import API from '@/api';

export default {
    components: {
        ContentContainer,
        BaseTemplate,
        ActivityLabel,
        SidebarEvents,
        SidebarOpeningshours,
    },
    computed: {
        headerImage() {
            if(!this.product.image['1240x1240']) {
                return FallbackImage(this.product.id);
            } else {
                return this.product.image['1240x1240'];
            }
        },
        ageGroup() {
            return this.$store.state.ageGroups[this.product.age_group];
        },
        targetAudience() {
            return this.$store.state.targetAudience[this.product.target_audience];
        },
        campaign() {
            return this.$route.params.campaign;
        }
    },
    data() {
        return {
            product: null,
        };
    },
    beforeRouteEnter(to, from, next) {
        API.ijstijd.getProduct(to.params.activity_id, to.params.campaign).then((response) => {
            next(vm => vm.setData(response.data.product));
        }, () => {
            next('404');
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.product = null;

        API.ijstijd.getProduct(to.params.activity_id).then((response) => {
            this.setData(response.data.product);
        }, () => {
            next('404');
        });
    },
    methods: {
        setData(product) {
            this.product = Object.assign({}, {
                location: {},
                provider: {},
            }, product);
        },
    },
};
</script>
